module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Chapters"
  }, [_c('span', [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph"
  }, [_vm._v("I "), _c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("stood behind the counter, eyes locked on that treacherous store room door. I didn’t need a mirror to know how pale my skin was. No doubt I looked like a zombie clerk extra from a Night of the Living Dead remake. I knew what I needed to do, but I couldn’t quite force myself to start moving.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“Mmph…ptui. I tried to tell you it was too damn cold back there.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“What’s the temperature mean? How did he freeze to death in the store’s back room?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“First, he didn’t freeze to death. His heart was ripped from his chest AND he froze to death. From the looks of it, either one could have killed him. Second, store that formula away for later use: Cold equals bad, very bad. Right now, we’ve got more important things to worry about.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“Yeah, I know.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("The smart money was on wiping down any surface I touched, taking the stuff I came for, and getting back to Dorothy ASAP. The cops rarely like occupations that can be summed up as aspiring vagrant. My alibi for the last day was less than stellar. I could imagine the interrogation now:")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("Cop: Mr. Fisher, where were you when he was killed?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("Me: Sitting under a tree by the lake. Or maybe I was walking from my car to the murder scene.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("Cop: Can anybody verify that?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("Me: Well, there’s a nice oak tree, but…do you have anyone on staff that speaks Plant?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("The best I could hope for was an insanity plea. If I was lucky, whatever it was about me that fouled up smart phones and laptops had royally screwed up the store’s surveillance system. If I hurried, I could be two states away before sunrise.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("There’s a lot of words that could be used to describe me: College dropout, weirdo loner, polyglot, wizard-wannabe. Unfortunately, lucky and amoral were not among them. The security system was working. Worse, I couldn’t force myself to walk away from this. There was a chance I'd seen or heard something that might help the police catch the sicko who did this.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“If you pick up the phone to call 911, you’ll regret it,” my annoying inner voice warned.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“I don’t have a choice. If I don’t call the cops, it’ll just make me look guilty.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“Colin, you really don’t want to touch that phone.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I hesitated, but I lifted it from its cradle anyway. It was a land-line and as old as I was. No dial tone. I tried hitting 9 to see if that would let me call out. Still no dial tone, but the line wasn’t dead silence either.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Hello?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("There was no answer, but the background noise got louder. It sounded like heavy breathing…no, heavy panting, like a Saint Bernard after a long sprint. My eyes returned to the back door, still slightly ajar. I was suddenly wondering whether the man’s heart was torn out or eaten out by a giant canine-esque maw.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Whoever this is, you don’t want to screw with me.” I could only hope I didn’t sound as scared as I was. “I know magic.” I meant to say I had a gun, but the other slipped out before my brain-to-mouth editor could get a handle on it.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("The panting stopped and for a moment the line was blessedly silent. A terrible voice spoke, a rumbling stone-edged tongue uttering words full of strange clicks and guttural stops. It growled its way through four or five alien sentences before falling back into silence. I slammed the phone back into its cradle.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“What the hell was that?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“Cherokee, maybe. It was Native American, but I can’t place it. And what are you asking me for? You’re the linguistic genius.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“So you jump ship on the whole 'I’m just your shadow-side' thing when there’s blame to be placed, but when I come up with all the good ideas...”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“You know, I can find another gag.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“Okay, yeah. It was native. But it was OLD native.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“You’re thinking Mayan or Incan?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“Think older. Think whatever it was they all spoke before they came over the ice bridge.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“Did you catch any of it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“No, but I don’t need to translate to know what it was saying. It was threatening to eat our heart out, too.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“That’s about what I thought. Death threats have a rhythm all their own.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("My internal monologue was shattered by the ringing phone.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("BRRRINGG!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I stared at it, hand trembling.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("BRRRINGG!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I reached, but I couldn’t quite grab it before...")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("BRRRINGG!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I snatched it up, determined to deal with the monster. “Look, I don’t know who...”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Colin?” The speaker whispered, soft, distant, and breathless.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I was scared out of my mind, contemplating sorcerous counter-measures for an unknown assailant…but I still recognized that voice. “Dad?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Colin, Colin…I can’t see you, Colin.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Dad, it’s all right, I’m here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Colin, I’m sorry. I’m sorry, I didn’t tell you before…I know you didn’t hurt that girl.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Sarai. Her name was Sarai, Dad.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Sarai.” The sound was faint, as if the receiver were drifting away from his mouth. “I’m sorry I didn’t handle it better. I knew…I knew you were a good boy, Colin. I’m sorry, sorry, sorrryyyy...”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I nodded, a single tear rolling down my cheek. “I’m sorry I didn’t make it back soon enough. I would’ve liked to see you one last time. I love you, Dad.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I stood there with the phone pressed hard against my ear, hoping for an “I love you” that never came. The line, like my father, was dead.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3647a882","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0010.vue
// module id = 90
// module chunks = 0